import { c as _c } from "react/compiler-runtime";
import { HotelBtsCoverageProperties } from "@website/accommodation-ui/hotel-bts-coverage/hotel-bts-coverage.types";
import { LazyImage } from "@website/ui/lazy-image";
export const HotelBTSCoverage = t0 => {
  const $ = _c(5);
  const {
    btsCoverage
  } = t0;
  if (!btsCoverage?.length) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-subtitle-1 md:text-headline-6">وضعیت آنتن دهی</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== btsCoverage) {
    t2 = btsCoverage.map(_temp);
    $[1] = btsCoverage;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="flex flex-col justify-start gap-4">{t1}<div className="grid grid-cols-2 flex-row items-center gap-y-6 md:flex md:flex-wrap md:gap-[164px]">{t2}</div></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp(item) {
  return <div className="flex flex-row items-center gap-2" key={`${item?.cellOperator}-${item?.coverageType}`}>{item?.logo && <LazyImage src={item?.logo} width={40} height={20} />}<div className="flex flex-col gap-1"><span className="text-subtitle-2">{item?.cellOperator}</span><span className="text-body-2 text-on-surface-medium-emphasis">{item?.coverageType}</span></div></div>;
}